console.log('🚀 GM Predictive Analytics Store: Initializing predictive analytics module...');

const predictiveAnalytics = {
  namespaced: true,

  state: {
    predictiveData: {},
    forecastData: {},
    churnData: {},
    isLoading: false,
    error: null
  },

  mutations: {
    SET_PREDICTIVE_DATA(state, data) {
      console.log('🔮 GM Predictive Analytics: Setting predictive data:', data);
      state.predictiveData = data;
    },

    SET_FORECAST_DATA(state, data) {
      console.log('🔮 GM Predictive Analytics: Setting forecast data:', data);
      state.forecastData = data;
    },

    SET_CHURN_DATA(state, data) {
      console.log('🔮 GM Predictive Analytics: Setting churn data:', data);
      state.churnData = data;
    },

    SET_LOADING(state, isLoading) {
      console.log('🔄 GM Predictive Analytics: Setting loading state:', isLoading);
      state.isLoading = isLoading;
    },

    SET_ERROR(state, error) {
      console.log('❌ GM Predictive Analytics: Setting error:', error);
      state.error = error;
    },

    CLEAR_ERROR(state) {
      console.log('✅ GM Predictive Analytics: Clearing error');
      state.error = null;
    }
  },

  actions: {
    async fetchPredictiveData({ commit }, filters = {}) {
      try {
        console.log('🔮 GM Predictive Analytics: Fetching predictive data...');
        commit('SET_LOADING', true);
        commit('CLEAR_ERROR');

        const queryParams = new URLSearchParams(filters);
        const response = await fetch(`/api/v1/accounts/gm_analytics/predictive_analytics?${queryParams}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        console.log('✅ GM Predictive Analytics: Predictive data fetched successfully:', result);

        if (result.success) {
          commit('SET_PREDICTIVE_DATA', result.data);
        } else {
          throw new Error(result.error || 'Failed to fetch predictive data');
        }

        return result;
      } catch (error) {
        console.error('❌ GM Predictive Analytics: Error fetching predictive data:', error);
        commit('SET_ERROR', error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },

  getters: {
    predictiveData: (state) => state.predictiveData,
    forecastData: (state) => state.forecastData,
    churnData: (state) => state.churnData,
    isLoading: (state) => state.isLoading,
    error: (state) => state.error,
    hasData: (state) => Object.keys(state.predictiveData).length > 0
  }
};

console.log('✅ GM Predictive Analytics Store: Module created successfully');

export default predictiveAnalytics;
